module.exports = __webpack_public_path__ + "img/Terms of Service1.cf609fca.jpg";